import { BrowserRouter, Switch, Route } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import './App.css';
import LoadingPage from "./components/LoadingPage";
import Lower_topbar from "./components/Lower_topbar";
import Acceuil from './components/Pages/Acceuil';
import AboutUs from './components/Pages/AboutUs';
import Control from './components/Pages/Activites/Control';
import ControlCND from './components/Pages/Activites/ControlCND';
import ControlRSC from './components/Pages/Activites/ControlRSC';
import ControlCRS from './components/Pages/Activites/ControlCRS';
import contact from './components/Pages/Contact/Contact';
import Formation from './components/Pages/Formation/Formation';
import Qualite from './components/Pages/Qualite/qualite';
import Accreditation from './components/Pages/Accreditation/Accreditation';
import Secteurs from './components/Pages/Secteurs/Secteurs';
import { HelmetProvider } from 'react-helmet-async';  // Import HelmetProvider
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEng from './locales/eng/translation.json'; // Remplacez le chemin par le bon
import translationFr from './locales/fr/translation.json'; // Remplacez le chemin par le bon
import ScrollToTop from "react-scroll-to-top";


i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEng },
    fr: { translation: translationFr },
  },
  lng: localStorage.getItem('language') || 'fr', // Use language from local storage or default to 'fr'
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
});
function App() {

  const [loader, setLoader] = useState(true);

useEffect(() => {

    setTimeout(() => {
      document.documentElement.style.overflow = 'auto';
      document.documentElement.style.height = 'auto';
      setLoader(false);
    }, 3000);
  }, []);
  return  loader ?
      (
          <LoadingPage />
      )
      :
      (
    
    <>
    <HelmetProvider>
        <BrowserRouter>
          <Lower_topbar />
          <Navbar />
          <Switch>
            <Route path='/' exact component={Acceuil} />
            <Route path='/about_us' component={AboutUs} />
            <Route path='/control' component={Control} />
            <Route path='/controlCND' component={ControlCND} />
            <Route path='/controlRSC' component={ControlRSC} />
            <Route path='/controlCRS' component={ControlCRS} />
            <Route path='/contact' component={contact} />
            <Route path='/secteurs' component={Secteurs} />
            <Route path='/formation' component={Formation} />
            <Route path='/qualite' component={Qualite} />
            <Route path='/accreditation' component={Accreditation} />
          </Switch>
          <ScrollToTop smooth />        
          </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

export default App;
